function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "NewRelic-logo-bug-clr-w");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M464.21,403.67,444,361.34c-4.82-10-9.77-21.36-11.46-26.7l-.39.39c.65,7.55.78,17.06.91,25l.52,43.63H418.89V313.55h16.93l21.88,44a164.22,164.22,0,0,1,9.25,23.18l.39-.39c-.39-4.56-1.3-17.45-1.3-25.66l-.26-41.15H480v90.12Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M506.79,374.63v1c0,9.12,3.39,18.75,16.28,18.75,6.12,0,11.46-2.21,16.41-6.51l5.6,8.73a35.59,35.59,0,0,1-23.7,8.73c-18.62,0-30.34-13.41-30.34-34.51,0-11.59,2.47-19.27,8.21-25.79,5.34-6.12,11.85-8.86,20.19-8.86a25.45,25.45,0,0,1,18.1,6.77c5.73,5.21,8.6,13.28,8.6,28.65v3ZM519.42,347c-8.07,0-12.5,6.38-12.5,17.06h24.35C531.28,353.4,526.59,347,519.42,347Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M622.3,403.93H608.89l-8.07-30.34c-2.08-7.81-4.3-18-4.3-18h-.26s-1,6.51-4.3,18.62L584,403.93H570.6l-18-65.25,14.2-2L574,368.64c1.82,8.21,3.39,17.32,3.39,17.32h.39a178.89,178.89,0,0,1,3.78-17.71L590,337.77h14.07l7.42,29.69c2.74,10.68,4.17,18.75,4.17,18.75h.39s1.56-10,3.26-17.71l6.77-30.73h14.85Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M724.4,403.67l-7.81-13.94c-6.25-11.07-10.42-17.32-15.37-22.27a7.64,7.64,0,0,0-5.86-2.74v38.94H680.64V313.55h27.48c20.19,0,29.3,11.72,29.3,25.79,0,12.89-8.33,24.74-22.4,24.74,3.26,1.69,9.25,10.42,13.93,18l13.28,21.62Zm-20.84-78h-8.21v28.52H703c7.81,0,12-1,14.72-3.78,2.47-2.47,4-6.25,4-10.94C721.8,330.35,716.85,325.66,703.56,325.66Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M761.9,374.63v1c0,9.12,3.39,18.75,16.28,18.75,6.12,0,11.46-2.21,16.41-6.51l5.6,8.73a35.59,35.59,0,0,1-23.7,8.73c-18.62,0-30.34-13.41-30.34-34.51,0-11.59,2.47-19.27,8.21-25.79,5.34-6.12,11.85-8.86,20.19-8.86a25.45,25.45,0,0,1,18.1,6.77c5.73,5.21,8.6,13.28,8.6,28.65v3ZM774.54,347c-8.07,0-12.5,6.38-12.5,17.06h24.35C786.39,353.4,781.7,347,774.54,347Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M828.06,405.1c-14.46,0-14.46-13-14.46-18.62V330.35a106.72,106.72,0,0,0-1.3-19.27L827,307.82c1,4,1.17,9.51,1.17,18.1v55.87c0,8.86.39,10.29,1.43,11.85a4,4,0,0,0,4.69,1l2.34,8.86A22.48,22.48,0,0,1,828.06,405.1Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M852.93,328a9.34,9.34,0,0,1-9.25-9.51,9.44,9.44,0,1,1,9.25,9.51Zm-7.16,75.67V338.81l14.46-2.6v67.46Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M901.25,405.36c-18,0-28-12.63-28-33.86,0-24,14.33-35.42,29-35.42,7.16,0,12.37,1.69,18.23,7.16l-7.16,9.51c-3.91-3.52-7.29-5.08-11.07-5.08a11.2,11.2,0,0,0-10.42,6.64c-2,4-2.73,10.16-2.73,18.36,0,9,1.43,14.72,4.43,18a11.58,11.58,0,0,0,8.73,3.78c4.56,0,9-2.21,13.28-6.51l6.77,8.73C916.35,402.63,910.1,405.36,901.25,405.36Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M934.56,405.11a9.67,9.67,0,1,1,9.62-9.67A9.63,9.63,0,0,1,934.56,405.11Zm0-17.42a7.78,7.78,0,1,0,7.44,7.75A7.55,7.55,0,0,0,934.56,387.69Zm1.9,13.1c-.42-.73-.6-1-1-1.79-1.07-2-1.4-2.5-1.79-2.65a.71.71,0,0,0-.34-.08v4.52h-2.13V390h4a3,3,0,0,1,3.2,3.17,2.78,2.78,0,0,1-2.42,3,2.44,2.44,0,0,1,.44.47c.62.78,2.6,4.21,2.6,4.21Zm-1.14-8.94a4.35,4.35,0,0,0-1.22-.16h-.78v2.94H934c.94,0,1.35-.1,1.64-.36a1.53,1.53,0,0,0,.42-1.09A1.27,1.27,0,0,0,935.32,391.85Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M279.8,433.71c-37.34,0-67.9-20.61-74.31-50.13-7.86-36.17,22.64-73.62,68-83.49a104.77,104.77,0,0,1,22.22-2.41c37.34,0,67.9,20.61,74.31,50.12,3.83,17.61-1.19,36-14.14,51.81s-32,26.92-53.86,31.68A104.73,104.73,0,0,1,279.8,433.71Zm15.9-132A100.76,100.76,0,0,0,274.34,304c-43.2,9.39-72.34,44.71-64.94,78.73,6,27.66,35,47,70.4,47a100.79,100.79,0,0,0,21.37-2.32c21-4.57,39.34-15.33,51.61-30.3s16.89-32,13.33-48.43C360.1,321,331.15,301.68,295.71,301.68Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M294.92,415.38a48.52,48.52,0,1,1,48.53-48.52A48.58,48.58,0,0,1,294.92,415.38Zm0-93a44.52,44.52,0,1,0,44.53,44.52A44.57,44.57,0,0,0,294.92,322.34Z",
  transform: "translate(-204.25 -297.68)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M287.76,396a30.3,30.3,0,1,1,30.3-30.3A30.34,30.34,0,0,1,287.76,396Zm0-56.6a26.3,26.3,0,1,0,26.3,26.3A26.33,26.33,0,0,0,287.76,339.4Z",
  transform: "translate(-204.25 -297.68)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "b_w_-_logo",
    "data-name": "b/w - logo",
    viewBox: "0 0 739.93 136.03"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

export default __webpack_public_path__ + "static/media/newrelic.8844ed23.svg";
export { SvgComponent as ReactComponent };